import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { routes } from '@platform/core/lib/routes';
import { ModuleStringsProvider } from '@platform/modularity/ModuleStringsProvider';
import { useModuleDefinition } from '@platform/modularity/useModuleDefinition';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { moduleNav } from '@platform/navigation';
import { useGetRecordQuery } from '@platform/state/api';
import { Dialog, ModuleTile, Spinner } from '@platform/ui';
import type { IMiniFormDialogProps } from './IMiniFormDialogProps';
import { recordCode } from '../header/recordCode';
import { MiniFormBody } from './MiniFormBody';
import './miniForm.css';

/**
 * Міні-форма запису (UIUX forms/form-variants, прототип v4 «Швидка форма»): спливне вікно до 560px і 84vh — плитка модуля, «{тип} {номер}» (без префікса типу)
 * дрібним, кнопка «Відкрити повну форму ↗», ×; зміни зберігаються одразу й пишуться в історію; Esc закриває; інших діалогів не відкриває.
 */
export function MiniFormDialog({ ws, target, onClose }: IMiniFormDialogProps) {
  const { t } = useTranslation();
  const { data: module } = useModuleDefinition(target.module);
  const strings = useModuleStrings(target.module);
  const { data: record } = useGetRecordQuery({ ws, rt: target.recordType, id: target.id });
  const rt = module?.recordTypes.find((r) => r.key === target.recordType);
  const type = rt ? strings.entity(rt.key, 'singular', rt.singular ?? rt.name) : '';
  const nav = moduleNav(target.module);
  return (
    <ModuleStringsProvider strings={strings}>
      <Dialog title={record ? t('recordPage.mini.title', { type, code: recordCode(record.display, record.code) }) : t('app.loading')} onClose={onClose}
        actions={(
          <>
            <span className="rec-mini__tile" aria-hidden><ModuleTile icon={nav.icon} tone={nav.tone} size={30} /></span>
            <Link className="rec-mini__full" to={routes.record(target.module, target.recordType, target.id)} onClick={onClose}>{t('recordPage.mini.openFull')}</Link>
          </>
        )}>
        {module && rt && record ? <MiniFormBody ws={ws} module={module} rt={rt} record={record} onClose={onClose} /> : <Spinner />}
      </Dialog>
    </ModuleStringsProvider>
  );
}
